import Cookies from 'js-cookie';
import $ from 'jquery';

const COOKIES_ACCEPT_COOKIE_NOTICE_NAME = 'accept-cookies';
const COOKIE_NOTICE_ACCEPT_ACTION_SELECTOR = '[data-cookie-notice-accept]';
const COOKIE_NOTICE_SELECTOR = '.cookie-bar';

export default class CookieNotice {
    constructor() {
        this.setupEvents();

        this.refreshNotice();
    }

    setupEvents() {
        $(document).on(
            'click',
            COOKIE_NOTICE_ACCEPT_ACTION_SELECTOR,
            (ev) => {
                this.onCookieAcceptClick(ev);
            }
        );
    }

    hasAccepted() {
        return Cookies.get(COOKIES_ACCEPT_COOKIE_NOTICE_NAME);
    }

    setAccepted(flag) {
        return Cookies.set(COOKIES_ACCEPT_COOKIE_NOTICE_NAME, flag);
    }

    refreshNotice() {
        if (this.hasAccepted()) {
            $(COOKIE_NOTICE_SELECTOR).remove();
        }
    }

    onCookieAcceptClick(ev) {
        ev.preventDefault();

        this.setAccepted(true);

        this.refreshNotice();
    }
}


// WEBPACK FOOTER //
// ./assets/scripts/front/App/CookieNotice.js